import React from 'react';
import { SignUpPageLayout } from '../layout/SignUpPageLayout';
import { SignNavigationBar } from '../component/navigation-bar/SignNavigationBar';
import { SignUpDiv } from '../component/sign-up/customer/SignUpDiv';

export const SignUpPageCustomer = () => (
  <SignUpPageLayout
    navigationBar={<SignNavigationBar />}
    centerDesktop={<SignUpDiv />}
  />
);
